<div>
    <p>Viewing details for: <strong>{{providerName}}</strong></p>
</div>
<div class="app-student-scheduler-assessment-pannel">
    <kendo-scheduler [kendoSchedulerBinding]="events" [eventClass]="getSchedulerEventColor" [selectedDate]="selectedDate" style="height: 789px;" [eventHeight]="100"
        (dateChange)="onDateChange($event)">
        <ng-template kendoSchedulerEventTemplate let-event="event">
            <div *ngIf="event?.dataItem?.isHoliday; else regularEventContent">
              <span class="!k-font-semibold">{{ event?.dataItem?.title }}</span>
            </div>
            <ng-template #regularEventContent>
                <div #target kendoPopoverAnchor [popover]="viewScheduleEvent" #popoverAnchor="kendoPopoverAnchor"
                    (click)="onViewScheduleEvent(event, popoverAnchor)">
                    <div *ngIf="event?.dataItem?.scheduleType === 'Evaluator'">
                        <strong class="k-font-semibold">[EN]<span> {{ event?.dataItem?.title }}</span></strong>
                        <p class="!k-m-0">
                            <small>
                                [{{event?.dataItem?.location}}] -
                                {{event?.dataItem?.studentName}}
                            </small>
                        </p>
                    </div>
                    <div *ngIf="event?.dataItem?.sessionType === 1 && event?.dataItem?.scheduleType === 'Provider'">
    
                        <strong class="k-font-semibold">[{{ event?.dataItem?.language }}]
                            {{event?.dataItem?.serviceType}} -
                            {{event?.dataItem?.studentMandates?.length}}/{{getGroupSize(event?.dataItem?.groupSize)}}</strong>
                        <p class="!k-m-0"><small>{{ event?.dataItem?.location }}</small></p>
                    </div>
                    <div *ngIf="event?.dataItem?.sessionType !== 1 && event?.dataItem?.scheduleType === 'Provider' ">
                        <strong class="k-font-semibold">{{event?.dataItem?.sessionTypeName}}</strong>
                        <p class="!k-m-0" *ngIf="getLocationBySessionType(event?.dataItem?.sessionType)"><small>{{
                                event?.dataItem?.location }}</small></p>
                    </div>
                </div>
            </ng-template>
        </ng-template>
        <kendo-scheduler-work-week-view [eventHeight]="28"></kendo-scheduler-work-week-view>
    </kendo-scheduler>
</div>

<kendo-popover #viewScheduleEvent [width]="420" position="right" [templateData]="getViewScheduleEventData"
    style="border-radius: 14px;">
    <ng-template kendoPopoverTitleTemplate let-data="data">
        @if(this.currentEventData?.scheduleType === 'Provider'){
            <div>
                <div class="k-d-flex k-justify-content-between k-align-items-center">
                    <div class="k-d-flex k-align-items-center k-gap-sm" *ngIf="data.sessionType === 1">
                        <kendo-svg-icon [icon]="calendar" size="xlarge" themeColor="primary"></kendo-svg-icon>
                        <h4 class="!k-m-0 !k-p-0">[{{data.language}}] {{data.serviceType}} -
                            {{data?.selectedStudentMandates?.length}}/{{getGroupSize(data?.groupSize)}}</h4>
                        </div>
                        <div class="k-d-flex k-align-items-center k-gap-sm" *ngIf="data.sessionType !== 1">
                            <kendo-svg-icon [icon]="calendar" size="xlarge" themeColor="primary"></kendo-svg-icon>
                            <h4 class="!k-m-0 !k-p-0">{{data.sessionTypeName}}</h4>
                        </div>
                        <div>
                            <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small"
                        (click)="onCloseViewScheduleEvent()" title="Close"></button>
                </div>
            </div>
        </div>
    }
    @else{
        <div>
            <div class="k-d-flex k-justify-content-between k-align-items-center">
                <div class="k-d-flex k-align-items-center k-gap-sm">
                    <kendo-svg-icon [icon]="calendar" size="xlarge" themeColor="primary"></kendo-svg-icon>
                    <!-- [{{data?.language}}] -->
                    <h4 class="!k-m-0 !k-p-0"><span>[EN]</span> &nbsp; {{data?.title}}
                    </h4>
                </div>
                <div>
                    <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small"
                        (click)="onCloseViewScheduleEvent()" title="Close"></button>
                </div>
            </div>
        </div>
    }
    </ng-template>

    <ng-template kendoPopoverBodyTemplate let-data="data">
        <div class="view-schedule-popover-body">
            <div class="k-d-flex k-align-items-center k-gap-lg">
                <kendo-svg-icon [icon]="clockIcon" size="medium"></kendo-svg-icon>
                <p>{{data?.meetingDate}}, {{data?.startTime | date:'h:mm a'}} - {{data?.endTime | date:'h:mm a'}}</p>
            </div>
            <div *ngIf="data.sessionType === 1">
                <div class="k-d-flex k-align-items-center k-gap-lg">
                    <kendo-svg-icon [icon]="users" size="medium"></kendo-svg-icon>
                    <p class="font-12 secondary-color k-my-0">Students/Mandates</p>
                </div>
                <div class="k-ml-8">
                    <p class="k-mt-0">{{data?.studentMandates}}</p>
                </div>
            </div>
            @if(data?.scheduleType === 'Evaluator'){
                <div>
                    <div class="k-d-flex k-align-items-center k-gap-lg">
                        <kendo-svg-icon [icon]="users" size="medium"></kendo-svg-icon>
                        <p class="font-12 secondary-color k-my-0">Students</p>
                    </div>
                    <div class="k-ml-8">
                        <p class="k-mt-0">{{data?.studentName}} <span>(ID:
                                {{data?.nycId}})</span></p>
                    </div>
                </div>
            }
            <div *ngIf="data.sessionType === 1 || data?.scheduleType === 'Evaluator'">
                <div class="k-d-flex k-align-items-center k-gap-lg">
                    <kendo-svg-icon [icon]="locationDot" size="medium"></kendo-svg-icon>
                    <strong>{{data?.locationType}}</strong>
                </div>
                <div class="k-ml-8">
                    <p class="k-my-0 location-text">
                        {{ data?.location }}
                    </p>
                </div>
            </div>
            <div class="k-d-flex k-align-items-center k-gap-lg" *ngIf="data.sessionType === 1">
                <kendo-svg-icon [icon]="stairs" size="medium"></kendo-svg-icon>
                <p class="location-text">{{data?.floorRoom}}</p>
            </div>
            @if(data?.scheduleType === 'Evaluator'){
                <div class="k-d-flex k-align-items-center k-gap-lg">
                    <kendo-svg-icon [icon]="stairs" size="medium"></kendo-svg-icon>
                    <p class="location-text">{{data?.floorRoom}}</p>
                </div>
            }
            <div class="k-d-flex k-align-items-center k-gap-lg k-ml-8 k-mt-4 k-mb-4"
                *ngIf="data.sessionType === 1 || data?.scheduleType === 'Evaluator'">
                <kendo-label [for]="switch" text="Teams Meeting / Tele"></kendo-label>
                <kendo-switch #switch [readonly]="readonly" [(ngModel)]="data.teamsMeeting"></kendo-switch>
            </div>
        </div>
    </ng-template>

   
</kendo-popover>